import { globals, seo, single, page, channel, jobs } from './_api'

// const getTranslations = ({ commit }) => {
//     return new Promise((resolve, reject) => {
//         getAllTranslations({ lang: 'nl' })
//         .then(result => {
//             return resolve(result)
//         })
//         .catch(error => {
//             const message = error.response.data.message
//             reject(new Error(message))
//         })
//     })
// }

const getGlobals = ({ commit }, { lang }) => {
    return new Promise((resolve, reject) => {
        globals({ lang })
        .then(result => {
            commit('setGlobals', { globals: result })
            return resolve(result)
        })
        .catch(error => {
            const message = error.response.data.message
            reject(new Error(message))
        })
    })
}

const getSeo = ({ commit, dispatch }, { slug }) => {
    return new Promise((resolve, reject) => {
        seo({ slug: slug })
        .then(result => {
            commit('setSeo', { seo: result.data, slug: slug })
            commit('setSeoPath', { path: slug })
        }).then(result => {
            resolve(result)
        }).catch(error => {
            console.log(error)
        })
    })
}

const getSingle = ({ commit }, { slug, lang }) => {
    return new Promise((resolve, reject) => {
        single({ slug, lang })
        .then(result => {
            commit('setPage', { result: result, slug: slug })
            return resolve(result)
        })
        .catch(error => {
            const message = error.response.data.message
            reject(new Error(message))
        })
    })
}

const getChannel = ({ commit }, { handle, slug, lang }) => {
    return new Promise((resolve, reject) => {
        channel({ handle, slug, lang })
        .then(result => {
            commit('setPage', { result: result, slug: slug })
            return resolve(result)
        })
        .catch(error => {
            const message = error.response.data.message
            reject(new Error(message))
        })
    })
}

const getPage = ({ commit }, { slug, lang }) => {
    return new Promise((resolve, reject) => {
        page({ slug, lang })
        .then(result => {
            commit('setPage', { result: result, slug: slug })
            return resolve(result)
        })
        .catch(error => {
            const message = error.response.data.message
            reject(new Error(message))
        })
    })
}

const getJobs = ({ commit }, { lang }) => {
    return new Promise((resolve, reject) => {
        jobs({ lang })
        .then(result => {
            commit('setJobs', { result: result })
            return resolve(result)
        })
        .catch(error => {
            const message = error.response.data.message
            reject(new Error(message))
        })
    })
}

const addEventListeners = ({ commit, dispatch }) => {
    const input = document.querySelectorAll('input, textarea')
    for (var i = 0; i < input.length; i++) {
        const el = input[i]
        if (el !== undefined) dispatch('checkValue', { e: el })
        input[i].addEventListener('keyup', function (e) {
            dispatch('checkValue', { e })
        })
    }

    const select = document.querySelectorAll('select')
    for (var index = 0; index < select.length; index++) {
        const el = select[index]
        if (el !== undefined) dispatch('checkValue', { e: el })
        select[index].addEventListener('change', function (e) {
            dispatch('checkValue', { e })
        })
    }
}

const checkValue = ({ commit, dispatch }, { e }) => {
    let target
    if (e.target === undefined) {
        target = e
    } else target = e.target

    if (target.type === 'checkbox' || target.type === 'hidden') return

    const value = target.value
    if (value !== '') {
        target.previousElementSibling.classList.add('has-value')
        target.parentNode.classList.add('has-value')
    } else {
        target.previousElementSibling.classList.remove('has-value')
        target.parentNode.classList.remove('has-value')
    }
}

const validateFields = ({ commit, dispatch }, { fields }) => {
    let valid = true

    /* eslint-disable */
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    /* eslint-enable */

    for (var i = 0; i < fields.length; i++) {
        const field = fields[i]
        const value = field.value

        if (value === '') {
            field.parentNode.classList.add('has-error')
            valid = false
        } else if (field.type === 'email' && !re.test(String(field.value).toLowerCase())) {
            field.parentNode.classList.add('has-error')
            valid = false
        } else if (field.type === 'checkbox' && !field.checked) {
            field.parentNode.classList.add('has-error')
            valid = false
        } else {
            field.parentNode.classList.remove('has-error')
        }
    }

    return valid
}

// Export
export default {
    // getTranslations,
    getGlobals,
    getSeo,
    getPage,
    getJobs,
    getSingle,
    getChannel,
    addEventListeners,
    checkValue,
    validateFields
}
